import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\" id=\"phone\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m8.284 9.623 2.499-2.315L8.673 3l-2.845.198C.95 9.605 12.422 24.214 19.792 20.983l.865-2.722-3.683-3.068-2.837 1.882c-2.276-1.861-4.6-4.782-5.853-7.452Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol